import { render } from "./AppCloud.vue?vue&type=template&id=b23b2180&ts=true"
import script from "./AppCloud.vue?vue&type=script&lang=ts"
export * from "./AppCloud.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__